import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function ProfileAddIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M14 20.5h-4c-3.771 0-5.657 0-6.828-1.172C2 18.157 2 16.271 2 12.5v-1c0-3.771 0-5.657 1.172-6.828C4.343 3.5 6.229 3.5 10 3.5h4c3.771 0 5.657 0 6.828 1.172C22 5.843 22 7.729 22 11.5" />
      <path d="M5 16c1.036-2.581 4.896-2.75 6 0" />
      <path d="M9.75 9.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" />
      <path d="M14 8.5h5M14 12h2.5" />
      <path d="M19 21v-7m-3.5 3.5h7" />
    </SvgIcon>
  );
}
